import { render } from "./DefaultMessage.vue?vue&type=template&id=7fb58d1a&scoped=true"
import script from "./DefaultMessage.vue?vue&type=script&lang=js"
export * from "./DefaultMessage.vue?vue&type=script&lang=js"

import "./DefaultMessage.vue?vue&type=style&index=0&id=7fb58d1a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb58d1a"]])

export default __exports__